class BBSQuickView {
  constructor() {
    this.modal = document.querySelector('[data-bbs-quick-view-modal]');
    if (!this.modal) return;

    this.dialog = this.modal.querySelector('[data-bbs-quick-view-dialog]');
    this.content = this.modal.querySelector('[data-bbs-quick-view-body]');
    this.closeButtons = this.modal.querySelectorAll('[data-bbs-quick-view-close]');

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-bbs-quick-view-trigger]');
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();
      this.open(trigger.dataset.productUrl);
    });

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', () => this.close());
    });

    this.modal.addEventListener('click', (event) => {
      if (event.target === this.modal) {
        this.close();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.modal.classList.contains('is-open')) {
        this.close();
      }
    });
  }

  open(productUrl) {
    if (!productUrl || !this.content) return;

    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bbs-quick-view-open');
    this.content.innerHTML = '<p class="bbs-quick-view__loading">Loading…</p>';

    const fetchUrl = productUrl.includes('?')
      ? `${productUrl}&section_id=bbs-quick-view`
      : `${productUrl}?section_id=bbs-quick-view`;

    fetch(fetchUrl)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const section = doc.querySelector('[data-bbs-quick-view-content]');
        this.content.innerHTML = section ? section.outerHTML : html;

        const productRoot = this.content.querySelector('[data-bbs-product-page]');
        if (productRoot && window.BBSProductPage) {
          new window.BBSProductPage(productRoot);
        }

        if (window.Shopify?.PaymentButton) {
          window.Shopify.PaymentButton.init();
        }
      })
      .catch(() => {
        this.content.innerHTML = '<p class="bbs-quick-view__loading">Unable to load product.</p>';
      });
  }

  close() {
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bbs-quick-view-open');
    this.content.innerHTML = '';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new BBSQuickView();
});
